/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const DonationContract = {

	delete (context, templateId, onSuccess, onError, options) {
		Api.delete(context,
			"/donation-contract"
			+ "?templateId=" + templateId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getDownload (context, templateId, onSuccess, onError, options) {
		Api.get(context,
			"/donation-contract/download"
			+ "?templateId=" + templateId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getGenerate (context, projectId, templateId, onSuccess, onError, options) {
		Api.get(context,
			"/donation-contract/generate"
			+ "?projectId=" + projectId
			+ "&templateId=" + templateId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getList (context, departmentId, onSuccess, onError, options) {
		Api.get(context,
			"/donation-contract/list"
			+ "?departmentId=" + departmentId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	post (context, file, departmentId, onSuccess, onError, options) {
		Api.post(context,
			"/donation-contract"
			+ "?file=" + file
			+ "&departmentId=" + departmentId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
